function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11 11.613V.025C4.842.534 0 5.684 0 11.974c0 1.547.303 3.021.836 4.378L11 11.613zm.841 1.263L1.462 17.717A11.995 11.995 0 0012 23.974c3.044 0 5.814-1.142 7.93-3.009l-8.089-8.089zm9.149 7.028a11.942 11.942 0 003.01-7.93 11.94 11.94 0 00-3.01-7.929l-7.929 7.929 7.929 7.93zm-1.06-16.92l-7.43 7.43V0a11.93 11.93 0 017.43 2.984z"
})));